<app-header></app-header>
<div class="image-container">
    <img style="padding: 0; margin: 0;" src="assets/navimage.png" width="100%" alt="Your Image">
    <div class="image-text">
      <p>Contact Us</p>
    </div>
  </div>    

<div class="bg-white" style="height: 10vh;"></div>  
    
      <div class="container-fluid">
        <div class="mx-2 mt-2"><h2><b>Frequently Asked Questions</b></h2></div>
    
      
          <!-- <div class="py-2 mt-2 d-flex"  *ngFor="let faqs of faqList"> -->
            <div class="py-2 mt-2 d-flex">
            <div class="container-fluid">
              <mat-accordion>
                    <mat-expansion-panel (opened)="panelOpenState = true"
                                     (closed)="panelOpenState = false">
                                     
                  <mat-expansion-panel-header>
                    <mat-panel-title class="d-flex">
                      <span>When does the admission process start?</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <span>Admission forms are available from Nov.</span>
                  <span>
    
                  </span>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
      </div>
    

      <app-footer></app-footer>